import React from 'react'
import styled from 'styled-components'


const TextArea = styled.textarea`
  width: 100%;
  max-width: 720px;
  min-height: 160px;    
  padding: 14px 18px;
  resize: vertical;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 16px;
  line-height: 1.45;
  color: #111827;

`

const Counter = styled.span`
  display: block;
  align-self: flex-start;   
  margin-top: -14px;        
  font: 12px/1 'Inter', sans-serif;
  color: #6b7280;
  text-align: left;
`

export default function LongTextInput({ value, max, onChange }) {
  const current = value.length || 0

  return (
    <>
      <TextArea
        placeholder="Digite o feedback"
        value={value}
        maxLength={max}
        onChange={e => onChange(e.target.value)}
      />
      {max && <Counter>{current}/{max}</Counter>}
    </>
  )
}
